var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LibraryList',{attrs:{"limit":35}})
}
var staticRenderFns = []

export { render, staticRenderFns }